export default __webpack_public_path__ + "static/media/Vector-11.f11c6b80.svg";